export const DEFAULT_BASE_TITLE = 'Base #';
export const DEFAULT_ICTO_TITLE = 'Prod. #';
export const DEFAULT_CONFIGID_TITLE = 'Config #';
export const TARGET_CATGORIES = ['HP Home Laptop PCs', 'HP Home Desktop PCs'];
